export function loadScript(url: string, id: string) {
    if (isScriptLoaded(id)) {
        return Promise.resolve();
    }

    // adding the script tag to the head as suggested before
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;

    const promise = new Promise((resolve) => {
        script.onload = resolve;
    });

    // fire the loading
    head!.appendChild(script);
    return promise;
}

function isScriptLoaded(id: string) {
    return document.querySelector(`script#${id}`);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/utils/scriptLoader.ts